import { render, staticRenderFns } from "./BundangHandlingOrder.vue?vue&type=template&id=50b30321&"
import script from "./BundangHandlingOrder.vue?vue&type=script&lang=js&"
export * from "./BundangHandlingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports